import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from '../../universal-nav/hooks/useUniversalNavContext';
const formatAccountsPlanData = (accountsPlanData) => {
    return {
        interval: accountsPlanData.interval,
        planType: accountsPlanData.plan_type,
        actions: accountsPlanData.actions,
        includedTasksPerMonth: accountsPlanData.included_tasks_per_month,
        meteredPricingTiers: accountsPlanData.metered_pricing_tiers.map(([numTasks, pricePerTask]) => ({
            numTasks,
            pricePerTask,
        })),
        limits: {
            isSelfServe: accountsPlanData.limits.is_self_serve,
        },
    };
};
export const useQueryAccountPlan = (accountId, planId, apiHostnameFromParams) => {
    const { apiHostname: apiHostnameFromContext } = useUniversalNavContext();
    const apiHostname = apiHostnameFromParams || apiHostnameFromContext;
    const result = useQuery({
        queryKey: ['accountPlan', accountId, planId],
        queryFn: async () => {
            if (!accountId || !planId)
                throw new Error('Missing either accountId or planId');
            const response = await fetch(`${apiHostname}/api/v3/accounts/${encodeURIComponent(accountId)}/plans/${encodeURIComponent(planId)}`, {
                credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const accountsPlanJson = await response.json();
            return accountsPlanJson;
        },
        select: formatAccountsPlanData,
        enabled: !!accountId && !!planId,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
//# sourceMappingURL=useQueryAccountPlan.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
